import React, { useState, useEffect } from 'react';
import './SearchAndFilterBar.css';
import CustomButton from '../CustomButton/CustomButton';
import { assets } from '../../../assets/assets';
import CustomModal from '../../JSX/CustomModal/CustomModal';
import PropTypes from 'prop-types';
import Dropdown from '../Dropdown/Dropdown';
import { useNavigate } from 'react-router-dom';

const PROPERTY_STATUS = [
    { label: 'Jeddah', value: 'Jeddah' },
    { label: 'Medina', value: 'Medina' },
    { label: 'Mecca', value: 'Mecca' },
    { label: 'Riyadh', value: 'Riyadh' }
];

const PROPERTY_STATUS3 = [
    { label: 'Ready', value: 'Ready' },
    { label: 'Under construction', value: 'Under construction' },
];

function SearchAndFilterBar({ onFilterSubmit }) {
    const [dropdownValue, setDropdownValue] = useState('');
    const [dropdownValue2, setDropdownValue2] = useState('');
    const [textInput1, setTextInput1] = useState('');
    const [textInput2, setTextInput2] = useState('');
    const [textInput3, setTextInput3] = useState('');
    const [searchKeyword, setSearchKeyword] = useState('');
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleOpenModal = () => setIsModalOpen(true);
    const handleCloseModal = () => setIsModalOpen(false);

    const onClose = () => {
        setIsModalOpen(false);
    };

    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchKeyword(value);
    };


    useEffect(() => {
        if (searchKeyword.length > 2) {
             onFilterSubmit({ searchKeyword });
        }
    }, [searchKeyword]);

    const handleSubmit = () => {
        const formData = {
            place: dropdownValue,
            noOfRooms: textInput1,
            startVal: textInput2,
            endVal: textInput3,
            Status: dropdownValue2,
        };

        if (typeof onFilterSubmit === 'function') {
            onFilterSubmit(formData); // Pass data to parent component
        } else {
            console.error('onFilterSubmit is not a function');
        }

        setIsModalOpen(false);
    };

    

    useEffect(() => {
        const wordCount = searchKeyword.trim().split(/\s+/).length;
        if (wordCount > 3) {
            onFilterSubmit({ searchKeyword });
        }
    }, [searchKeyword, onFilterSubmit]);

    const handleselectPropertyStatus = (selectedOption) => {
        setDropdownValue(selectedOption?.value);
    };
    const handleselectPropertyStatus3 = (selectedOption) => {
        setDropdownValue2(selectedOption?.value);
    };
    const handleClick = (type) => {
        navigate('/createOffer', { state: { offerType: type } });
    };
    const handleReset = () => {
        setDropdownValue(''); // Reset dropdown 1
        setDropdownValue2(''); // Reset dropdown 2
        setTextInput1(''); // Reset text input 1
        setTextInput2(''); // Reset text input 2
        setTextInput3(''); // Reset text input 3
        setSearchKeyword(''); // Reset search keyword
    };
    return (
        <>
            <div className="row-div-inputsBtn">
            <input
                    type="text"
                    id="text"
                    placeholder="Search Offer and Property"
                    className="input-text"
                    value={searchKeyword}
                    onChange={handleSearchChange}
                    required
                />
                <CustomButton style={{ padding: 20 }} onClick={() => { handleClick("Request") }}>
                    Send Request
                </CustomButton>
                <CustomButton style={{ padding: 20 }} onClick={() => { handleClick("Offer") }}>
                    Send Offer
                </CustomButton>
                <CustomButton
                    style={{ backgroundColor: '#333333', color: 'white', border: '1px solid #000', padding: 20 }}
                    className="custom-button" onClick={handleOpenModal} icon={assets.filterImg}>
                    Filter property
                </CustomButton>

                {isModalOpen && (
                    <div className="modal-overlay">
                        <div className="modal-content">
                            <div className="modal-header">
                                <span className="modal-header-title">Filter</span>
                                <span className="modal-close-icon" onClick={onClose}>
                                    &times;
                                </span>
                            </div>
                            <Dropdown
                                options={PROPERTY_STATUS}
                                onSelect={handleselectPropertyStatus}
                                placeholder="Select District"
                                value={dropdownValue}

                            />
                            <div style={{ marginTop: 20 }}>
                                <Dropdown
                                    options={PROPERTY_STATUS3}
                                    onSelect={handleselectPropertyStatus3}
                                    placeholder="Select Status"
                                    value={dropdownValue2}
                                />
                            </div>

                            <input
                                type="text"
                                value={textInput1}
                                onChange={(e) => setTextInput1(e.target.value)}
                                placeholder="Enter Number of Rooms"
                                className="modal-input"
                            />
                            {/* <div className="modal-row">
                                <input
                                    type="text"
                                    value={textInput2}
                                    onChange={(e) => setTextInput2(e.target.value)}
                                    placeholder="Price Start"
                                    className="modal-input"
                                />
                                <input
                                    type="text"
                                    value={textInput3}
                                    onChange={(e) => setTextInput3(e.target.value)}
                                    placeholder="Price End"
                                    className="modal-input"
                                />
                            </div> */}
                            <div className="modal-buttons">
                                <button onClick={handleSubmit} className="btn-submit">
                                    Submit
                                </button>
                                <button onClick={handleReset} className="btn-cancel">
                                    Reset
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}

SearchAndFilterBar.propTypes = {
    onFilterSubmit: PropTypes.func.isRequired,
};

export default SearchAndFilterBar;
